<template>
  <div>
    <h4
      class="myOrangeTitle"
      id="observations"      
      v-html="$t('views.themeView.title1')"
    ></h4>
    <div class="editorial" v-if="$t('views.themeView.introduction1')" v-html="$t('views.themeView.introduction1')"></div>
    <div class="observations-container">
      <info-message v-if="theme.subThemes.length==0" :text="$t('views.themeView.msgSubthemesEmpty')"/>
      <sub-theme-section
        v-for="(subTheme, index) in theme.subThemes"
        :key="subTheme.ref"
        :subTheme="subTheme"
        :id="index"
        :edit="edit"
        :themeAbbr="theme.abbreviation"
        :index="index"
        :subThemeInitLength="subThemeInitLength"
        v-on:ratingChanged="ratingChanged+=1"
      ></sub-theme-section>

      <b-button class="defaultButton add-btn" v-if="edit" block @click="$emit('addSubTheme')">
        <plus-icon title="" />{{$t('views.themeView.btnAddSubTheme')}}
      </b-button>
    </div>

    <h4 class="myOrangeTitle" id="objectifications" v-html="$t('views.themeView.title2')"></h4>
    <div class="editorial" v-if="$t('views.themeView.introduction2')" v-html="$t('views.themeView.introduction2')"></div>
    <div ref="objectificationsContainer" class="themeElementContainer">
      <levels-section
        :edit="edit"
        :themeAbbr="theme.abbreviation"
        :contentList="theme.objectificationElements"
        data-type="OBJECTIFICATIONS"
      ></levels-section>
    </div>

    <h4 class="myOrangeTitle" id="analyse" v-html="$t('views.themeView.title3')"></h4>
    <div class="editorial" v-if="$t('views.themeView.introduction3')" v-html="$t('views.themeView.introduction3')"></div>
    <div class="themeElementContainer">
      <h5 class="subtitle" v-html="$t('views.themeView.title3_subtitle1')"></h5>
      <textarea :name="ckEditorId" :id="ckEditorId" v-model="theme.analysis"></textarea>
    </div>
    <div class="empty-space"></div>
    <global-rating :theme="theme" :ratingChanged="ratingChanged"></global-rating>

    <h4 class="myOrangeTitle" id="progressProposals" v-html="$t('views.themeView.title4')"></h4>
    <div class="editorial" v-if="$t('views.themeView.introduction4')" v-html="$t('views.themeView.introduction4')"></div>
    <progress-proposals :edit="false" view="theme" :theme="theme"></progress-proposals>
  </div>
</template>


<script>
import SubThemeSection from "./SubThemeSection.vue";
import LevelsSection from "./LevelsSection.vue";
import ProgressProposals from "./ProgressProposals.vue";
import GlobalRating from "./GlobalRating.vue";
import InfoMessage from "../global/InfoMessage.vue";
import PlusIcon from 'vue-material-design-icons/Plus.vue';

export default {
  name: "Theme",
  components: {
      SubThemeSection,
      LevelsSection,
      ProgressProposals,
      GlobalRating,
      PlusIcon,
      InfoMessage
  },
  props: {
      theme: Object,
      edit: Boolean
      /*, floatingBarFixed: Boolean*/
  },
  data: function() {
      return {
          ratingChanged: 0, // permet de notifier à globalRating qu'une notation a été modifiée
          subThemeInitLength: 0 // utilisé pour identifier qu'on a ajouté un sous-thème et donc qu'il faut le déplier
      };
  },
  computed: {
    ckEditorId: function() {
      return "CK_"+this.theme.ref;
    }
  },
  created: function() {
    this.subThemeInitLength = this.theme.subThemes.length;

    this.updateNbDisplayedColumnsSettings(null);
    window.addEventListener("resize", this.updateNbDisplayedColumnsSettings);
  },
  mounted: function() {
    var that = this;
    CKEDITOR.replace( //eslint-disable-line no-undef
      this.ckEditorId,
      {
        on: {
          change: function() {
            var data = this.getData();
            const maxLength = 10000;
            if (data.length > maxLength) {              
              data=data.substring(0, maxLength);
              
              //TODO refermer les balisesHTML plus proprement 
              data=$('<div>').html(data).html();  //eslint-disable-line no-undef
              
              this.setData(data, { noSnapshot: true });
            }
            that.theme.analysis = data;
          }
        }
      }
    );
  },  
  watch: {
    'theme.subThemes.length': function() { 
      if(this.theme.subThemes.length<this.subThemeInitLength) {
        this.subThemeInitLength = this.theme.subThemes.length;
      }
    }
  },
  methods: {
    updateNbDisplayedColumnsSettings : function(event) {
      // --- DEBUT MODIFS https://jira.inrs.fr/browse/GPSST-10
      //var availWidth = Math.min(document.documentElement.clientWidth, 920) - 100;
      //var nbdc = Math.min(4, Math.floor(availWidth / 230));
      var clientWidth = document.documentElement.clientWidth;
      var nbdc = 4;
      if (clientWidth<480) {
        nbdc = 2;
      }
      else if (clientWidth<768) {
        nbdc = 3;
      }

      // var nbmc = Math.min(nbdc+1, 4);
      var nbmc = nbdc;
      
      //console.log("updateNbDisplayedColumnsSettings", clientWidth, nbdc, nbmc);
      // --- FIN MODIFS https://jira.inrs.fr/browse/GPSST-10

      // On met à jour le paramétrage uniquement si le nb de colonne max a changé
      if (this.$store.state.appState.themesColumns.nbMaxColumns != nbmc ) {
        this.$store.commit('SET_NB_MAX_COLUMNS', nbmc);

        if(!event) {
          this.$store.commit('SET_NB_DISPLAYED_COLUMNS', nbdc);
        }
        else if (this.$store.state.appState.themesColumns.nbDisplayedColumns > nbmc) {
          this.$store.commit('SET_NB_DISPLAYED_COLUMNS', nbmc);
        }
      }
    }
  }
};
</script>


<style lang="sass" scoped>
@import '../../sass/_variables.sass'

.observations-container
  padding-right: 0
  padding-left: 0

.obsMargin 
  margin-top: 50px

.add-btn
  text-align: left
  margin: 3px
  width: calc(100% - 5px)

.empty-space
  height: 20px

</style>


